import { applyMiddleware, compose, createStore } from 'redux';
import { load, save } from 'redux-localstorage-simple';
import thunk from 'redux-thunk';
import { STORE_INIT } from './actionTypes';
import rootReducer from './reducers/index';

const middleware = [thunk, save({ states: ['version'] })];

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
  rootReducer(),
  load({ states: ['version'] }), // load from localStorage
  composeEnhancers(applyMiddleware(...middleware)),
);

// dispatch action to let all reducers know that store was initialized
// mostly needed for session reducer
store.dispatch({ type: STORE_INIT });

export default store;
